// extracted by mini-css-extract-plugin
module.exports = {"button":"_3dhDPXsAeQKFy8AeuIjo-D","icon":"_308HCIQJd0Ee__Xb21LHGD"};